// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Pswp-module--overlay--1XEww","modal":"Pswp-module--modal--1z6dk"};